import clsx from 'clsx';

import { Button, Text } from '@/shared/ui';
import styles from './SuggestArticle.module.css';

interface SuggestArticleProps {
  className?: string;
}

export const SuggestArticle = ({ className }: SuggestArticleProps) => {
  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.container}>
        <div className={styles.content}>
          <Text
            fontSize={24}
            fontWeight={800}
            lineHeight={28}
            letterSpacing={-0.264}
            className={styles.title}
            variant="primary"
          >
            Есть данные, которые важно узнать миру? — Поделитесь ими!
          </Text>
          <Text
            fontSize={14}
            fontWeight={400}
            lineHeight="160%"
            fontFamily="var(--font-merriweather-mono)"
            className={styles.description}
          >
            Загрузите материалы — наша команда проверит их и подтвердит факты
          </Text>
          <a
            className={styles.link}
            href="mailto:i@crimerussia.com"
            target="_blank"
          >
            <Button className={styles.button}>
              <Text fontSize={14} fontWeight={600} lineHeight="20px">
                Отправить анонимно
              </Text>
            </Button>
          </a>
        </div>
        <div className={styles.background} />
      </div>
    </div>
  );
};
